import BaseClient from './BaseClient';

class OrgUnitGroupsClient extends BaseClient {
    countOrgUnitGroups(teamId, orgUnitId, params) {
        const url = `/api/v3/teams/${teamId}/org-units/${orgUnitId}/groups/count`;

        return this.makeCoreApiRequest(url, 'get', null, params);
    }

    listOrgUnitGroups(teamId, orgUnitId, params) {
        const url = `/api/v3/teams/${teamId}/org-units/${orgUnitId}/groups`;

        return this.makeCoreApiRequest(url, 'get', null, params);
    }

    showOrgUnitGroup(teamId, orgUnitId, groupId) {
        const url = `/api/v3/teams/${teamId}/org-units/${orgUnitId}/groups/${groupId}`;

        return this.makeCoreApiRequest(url, 'get');
    }

    createOrgUnitGroup(teamId, orgUnitId, data) {
        const url = `/api/v3/teams/${teamId}/org-units/${orgUnitId}/groups`;

        return this.makeCoreApiRequest(url, 'post', data);
    }

    addOrgUnitGroup(teamId, orgUnitId, groupId) {
        const url = `/api/v3/teams/${teamId}/org-units/${orgUnitId}/groups/${groupId}`;

        return this.makeCoreApiRequest(url, 'post');
    }

    removeOrgUnitGroup(teamId, orgUnitId, groupId) {
        const url = `/api/v3/teams/${teamId}/org-units/${orgUnitId}/groups/${groupId}`;

        return this.makeCoreApiRequest(url, 'delete');
    }

    moveOrgUnitGroup(teamId, orgUnitId, groupId, targetOrgUnitId) {
        const url = `/api/v3/teams/${teamId}/org-units/${orgUnitId}/groups/${groupId}/move`;

        return this.makeCoreApiRequest(url, 'post', { target_org_unit_id: targetOrgUnitId });
    }
}

export default new OrgUnitGroupsClient();
